// ===== Enums =====

export enum LogicalOperator {
  And = 'And',
  Or = 'Or',
}

export enum Operator {
  Not = 'Not',
  And = 'And',
  Or = 'Or',
  IsOneOf = 'IsOneOf',
  StartsWith = 'StartsWith',
  Contains = 'Contains',
  ContainsAny = 'ContainsAny',
  ContainsAll = 'ContainsAll',
  EndsWith = 'EndsWith',
  IsEmpty = 'IsEmpty',
  Multiply = 'Multiply',
  Divide = 'Divide',
  Mod = 'Mod',
  Add = 'Add',
  Subtract = 'Subtract',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  Regex = 'Regex',
  DateAdd = 'DateAdd',
  DateInRange = 'DateInRange',
  Coalesce = 'Coalesce',
  IfElse = 'IfElse',
  WhenElse = 'WhenElse',
  IfEmpty = 'IfEmpty',
}

export enum DataType {
  Text = 'Text',
  Number = 'Number',
  Integer = 'Integer',
  Enumeration = 'Enumeration',
  Date = 'Date',
  DateTime = 'DateTime',
  TrueFalse = 'TrueFalse',
}

export enum MetadataContextType {
  FeeInitial = 'FeeInitial',
  FeeRequestValue = 'FeeRequestValue',
  FeeFinal = 'FeeFinal',
  FeeIncludeFee = 'FeeIncludeFee',
  FeeInitialTarget = 'FeeInitialTarget',
  FeeRequestValueTarget = 'FeeRequestValueTarget',
  FeeFinalTarget = 'FeeFinalTarget',
  WaterfallRequestValueTarget = 'WaterfallRequestValueTarget',
  WaterfallContext = 'WaterfallContext',
  WaterfallRequestValue = 'WaterfallRequestValue',
  LosMetadataFeeValue = 'LosMetadataFeeValue',
}

export enum SpecialFieldType {
  ServiceProviderSelection = 'ServiceProviderSelection',
}

export enum OperandType {
  None = 'None',
  Unary = 'Unary',
  Binary = 'Binary',
  BinaryArgs = 'BinaryArgs',
  UnaryArgs = 'UnaryArgs',
}

// ===== Interfaces =====

export interface SimpleBinaryExpression {
  left?: string | null;
  operator: Operator;
  right?: string[] | null;
  isNot?: boolean;
}

export interface ExpressionItem {
  expression?: SimpleBinaryExpression | null;
  expressionGroup?: SimpleExpression | null;
}

export interface SimpleExpression {
  expressions?: ExpressionItem[] | null;
  logicalOperator: LogicalOperator;
  isNot?: boolean;
}

export interface FieldMetadata {
  fieldName: string | null;
  dataType: DataType;
  isList: boolean;
  enumType: string | null;
  specialField?: SpecialFieldType | null;
  acceptsFormattedStrings?: boolean;
}

export interface OperatorInfo {
  operator: string;
  name: string | null;
  symbol: string | null;
  operandType: OperandType;
  isLogical: boolean;
  supportedDataTypes: DataType[];
}

